export const RECEIVE_CURRENT_USER = 'RECEIVE_CURRENT_USER';
export const EXPORT_VEGA = 'EXPORT_VEGA';
export const LOG_ERROR = 'LOG_ERROR';
export const PARSE_SPEC = 'PARSE_SPEC';
export const SET_BASEURL = 'SET_BASEURL';
export const SET_COMPILED_VEGA_PANE_SIZE = 'SET_COMPILED_VEGA_PANE_SIZE';
export const SET_DEBUG_PANE_SIZE = 'SET_DEBUG_PANE_SIZE';
export const SET_EDITOR_REFERENCE = 'SET_EDITOR_REFERENCE';
export const SET_GIST_VEGA_LITE_SPEC = 'SET_GIST_VEGA_LITE_SPEC';
export const SET_GIST_VEGA_SPEC = 'SET_GIST_VEGA_SPEC';
export const SET_MODE = 'SET_MODE';
export const SET_MODE_ONLY = 'SET_MODE_ONLY';
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';
export const SET_RENDERER = 'SET_RENDERER';
export const SET_VEGA_EXAMPLE = 'SET_VEGA_EXAMPLE';
export const SET_VEGA_LITE_EXAMPLE = 'SET_VEGA_LITE_EXAMPLE';
export const SET_VIEW = 'SET_VIEW';
export const SHOW_LOGS = 'SHOW_LOGS';
export const TOGGLE_AUTO_PARSE = 'TOGGLE_AUTO_PARSE';
export const TOGGLE_COMPILED_VEGA_SPEC = 'TOGGLE_COMPILED_VEGA_SPEC';
export const TOGGLE_DEBUG_PANE = 'TOGGLE_DEBUG_PANE';
export const TOGGLE_GIST_PRIVACY = 'TOGGLE_GIST_PRIVACY';
export const TOGGLE_NAV_BAR = 'TOGGLE_NAV_BAR';
export const UPDATE_EDITOR_STRING = 'UPDATE_EDITOR_STRING';
export const UPDATE_VEGA_LITE_SPEC = 'UPDATE_VEGA_LITE_SPEC';
export const UPDATE_VEGA_SPEC = 'UPDATE_VEGA_SPEC';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_THEME_NAME = 'SET_THEME_NAME';
export const SET_SIDEPANE_ITEM = 'SET_SIDEPANE_ITEM';
export const SET_COMPILEDPANE_ITEM = 'SET_COMPILEDPANE_ITEM';
export const SET_CONFIG_EDITOR_STRING = 'SET_CONFIG_EDITOR_STRING';
export const SET_LOG_LEVEL = 'SET_LOG_LEVEL';
export const SET_HOVER = 'SET_HOVER';
export const SET_TOOLTIP = 'SET_TOOLTIP';
export const CLEAR_CONFIG = 'CLEAR_CONFIG';
export const MERGE_CONFIG_SPEC = 'MERGE_CONFIG_SPEC';
export const EXTRACT_CONFIG_SPEC = 'EXTRACT_CONFIG_SPEC';
export const SET_SIGNALS = 'SET_SIGNALS';
export const ADD_SIGNAL = 'ADD_SIGNAL';
export const SET_DECORATION = 'SET_DECORATION';
export const SET_COMPILED_EDITOR_REFERENCE = 'SET_COMPILED_EDITOR_REFERENCE';
export const SET_EDITOR_FOCUS = 'SET_EDITOR_FOCUS';
export const SET_BACKGROUND_COLOR = 'SET_BACKGROUND_COLOR';
export const SET_RANGES = 'SET_RANGES';
export const ERROR = 'ERROR';
export const WARN = 'WARN';
export const INFO = 'INFO';
export const DEBUG = 'DEBUG';
export function setRanges(ranges) {
    return {
        ranges,
        type: SET_RANGES,
    };
}
export function setMode(mode) {
    return {
        mode,
        type: SET_MODE,
    };
}
export function setModeOnly(mode) {
    return {
        mode,
        type: SET_MODE_ONLY,
    };
}
export function setScrollPosition(position) {
    return {
        position,
        type: SET_SCROLL_POSITION,
    };
}
export function parseSpec(value) {
    return {
        parse: value,
        type: PARSE_SPEC,
    };
}
export function setVegaExample(example, spec) {
    return {
        example,
        spec,
        type: SET_VEGA_EXAMPLE,
    };
}
export function setVegaLiteExample(example, spec) {
    return {
        example,
        spec,
        type: SET_VEGA_LITE_EXAMPLE,
    };
}
export function updateVegaSpec(spec, config = undefined) {
    return {
        spec,
        config,
        type: UPDATE_VEGA_SPEC,
    };
}
export function updateVegaLiteSpec(spec, config = undefined) {
    return {
        spec,
        config,
        type: UPDATE_VEGA_LITE_SPEC,
    };
}
export function setGistVegaSpec(gist, spec) {
    return {
        gist,
        spec,
        type: SET_GIST_VEGA_SPEC,
    };
}
export function setGistVegaLiteSpec(gist, spec) {
    return {
        gist,
        spec,
        type: SET_GIST_VEGA_LITE_SPEC,
    };
}
export function toggleAutoParse() {
    return {
        type: TOGGLE_AUTO_PARSE,
    };
}
export function toggleCompiledVegaSpec() {
    return {
        type: TOGGLE_COMPILED_VEGA_SPEC,
    };
}
export function toggleDebugPane() {
    return {
        type: TOGGLE_DEBUG_PANE,
    };
}
export function logError(err) {
    return {
        error: { message: err.message },
        type: LOG_ERROR,
    };
}
export function updateEditorString(editorString) {
    return {
        editorString,
        type: UPDATE_EDITOR_STRING,
    };
}
export function exportVega(value) {
    return {
        export: value,
        type: EXPORT_VEGA,
    };
}
export function setRenderer(renderer) {
    return {
        renderer,
        type: SET_RENDERER,
    };
}
export function setBaseUrl(baseURL) {
    return {
        baseURL,
        type: SET_BASEURL,
    };
}
export function setView(view) {
    return {
        type: SET_VIEW,
        view,
    };
}
export function setDebugPaneSize(size) {
    return {
        debugPaneSize: size,
        type: SET_DEBUG_PANE_SIZE,
    };
}
export function showLogs(value) {
    return {
        logs: value,
        type: SHOW_LOGS,
    };
}
export function setCompiledVegaPaneSize(size) {
    return {
        compiledVegaPaneSize: size,
        type: SET_COMPILED_VEGA_PANE_SIZE,
    };
}
export function toggleNavbar(value) {
    return {
        navItem: value,
        type: TOGGLE_NAV_BAR,
    };
}
export function setSettingsState(value) {
    return {
        settings: value,
        type: SET_SETTINGS,
    };
}
export function setConfig(value) {
    return {
        configEditorString: value,
        type: SET_CONFIG,
    };
}
export function setConfigEditorString(value) {
    return {
        configEditorString: value,
        type: SET_CONFIG_EDITOR_STRING,
    };
}
export function setThemeName(value) {
    return {
        themeName: value,
        type: SET_THEME_NAME,
    };
}
export function setSidePaneItem(value) {
    return {
        sidePaneItem: value,
        type: SET_SIDEPANE_ITEM,
    };
}
export function setEditorReference(editorRef) {
    return {
        editorRef: editorRef,
        type: SET_EDITOR_REFERENCE,
    };
}
export function setCompiledEditorRef(editorRef) {
    return {
        editorRef: editorRef,
        type: SET_COMPILED_EDITOR_REFERENCE,
    };
}
export function setCompiledPaneItem(value) {
    return {
        compiledPaneItem: value,
        type: SET_COMPILEDPANE_ITEM,
    };
}
export function setLogLevel(logLevel) {
    return {
        logLevel,
        type: SET_LOG_LEVEL,
    };
}
export function setHover(hover) {
    return {
        hoverEnable: hover,
        type: SET_HOVER,
    };
}
export function setTooltip(tooltip) {
    return {
        tooltipEnable: tooltip,
        type: SET_TOOLTIP,
    };
}
export function clearConfig() {
    return {
        type: CLEAR_CONFIG,
    };
}
export function mergeConfigSpec() {
    return {
        type: MERGE_CONFIG_SPEC,
    };
}
export function extractConfigSpec() {
    return {
        type: EXTRACT_CONFIG_SPEC,
    };
}
export function setSignals(value) {
    return {
        signals: value,
        type: SET_SIGNALS,
    };
}
export function addSignal(value) {
    return {
        signal: value,
        type: ADD_SIGNAL,
    };
}
export function setDecorations(value) {
    return {
        decoration: value,
        type: SET_DECORATION,
    };
}
export function setEditorFocus(value) {
    return {
        editorFocus: value,
        type: SET_EDITOR_FOCUS,
    };
}
export function receiveCurrentUser(isAuthenticated, handle, name, profilePicUrl) {
    return {
        handle,
        isAuthenticated,
        name,
        profilePicUrl,
        type: RECEIVE_CURRENT_USER,
    };
}
export function toggleGistPrivacy() {
    return {
        type: TOGGLE_GIST_PRIVACY,
    };
}
export function setBackgroundColor(color) {
    return {
        type: SET_BACKGROUND_COLOR,
        color,
    };
}
export function addError(error) {
    return {
        type: ERROR,
        error,
    };
}
export function addWarning(warn) {
    return {
        type: WARN,
        warn,
    };
}
export function addInfo(info) {
    return {
        type: INFO,
        info,
    };
}
export function addDebug(debug) {
    return {
        type: DEBUG,
        debug,
    };
}
